import { useState } from 'react';
import EmbeddedSidebar from '../EmbeddedSidebar/EmbeddedSidebar';
import EmbeddedHeader from '../EmbeddedHeader/EmbeddedHeader';

const EmbeddedLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <>
            <EmbeddedSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <EmbeddedHeader toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
            {children}
        </>
    );
};

export default EmbeddedLayout;
